module.exports = __webpack_public_path__ + "img/ziyuan.8a11565f.png";